'use client';

import { Content, GroupField } from '@prismicio/client';
import { useState } from 'react';
import { Simplify } from '../../../../prismicio-types';
import { Switcher } from './Switcher';
import styles from './InnerContent.module.scss';
import Slides from './Slides/Slides';

interface Props {
  data: GroupField<
    Simplify<Content.PartnerPagesListSliceDefaultPrimarySlidesItem>
  >;
}

const InnerContent = ({ data }: Props) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className={styles.wrapper}>
      <Switcher
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        variant="default"
        switcher={data.map((el) => el.switcher_title)}
      />
      <Slides
        data={data}
        activeItem={data.findIndex((_, index) => index === activeTab)}
      />
    </div>
  );
};

export default InnerContent;
